<ax-icon *ngIf="icon" class="icon type-icon" [name]="icon"></ax-icon>
<mat-form-field
  class="c-input"
  [ngClass]="{'remove-subtext': !errorsTemplate && !hint, readonly: readonly}"
  appearance="outline"
  [floatLabel]="prefix ? 'always' : floatLabel"
  [subscriptSizing]="subscriptSizing"
>
  <mat-label>{{ label }}</mat-label>
  <div class="input-field">
    <span *ngIf="prefix" class="custom-prefix">
      {{ prefix }}
    </span>

    <input
      matInput
      axAutofocus
      [name]="getName()"
      type="email"
      [formControl]="valueForm"
      [autofocus]="autofocus"
      [placeholder]="placeholder"
      [autocomplete]="
        matAutocomplete?.options?.length ? 'no-autocomplete' : autocompleteAttr || 'email'
      "
      [matAutocomplete]="autocomplete"
      [matAutocompleteDisabled]="!matAutocomplete"
      [required]="required"
      (focus)="focused.emit()"
    />

    <span *ngIf="postfix" class="custom-prefix">
      {{ postfix }}
    </span>
  </div>

  <mat-hint class="hint" align="end">
    {{ hint }}
  </mat-hint>
  <span class="suffix" matSuffix>
    <ax-clear-button
      [form]="valueForm"
      *ngIf="hasValue && !valueForm.disabled && !readonly"
    ></ax-clear-button>
    <ng-content></ng-content>
  </span>

  <mat-error *ngIf="errorsTemplate">
    <ng-template [ngTemplateOutlet]="errorsTemplate"></ng-template>
  </mat-error>
</mat-form-field>
